/**
 * Spacing Tokens (Internal Design System)
 *
 * Consistent spacing values based on a 0.5rem (8px) base unit.
 * All spacing values are multiples of 0.5rem for visual rhythm.
 */

export const BASE_SPACING = 0.5

export const spacing = {
  negativeMicro: `-${BASE_SPACING / 2}rem`,
  negativePico: `-${BASE_SPACING / 4}rem`,
  none: '0',
  pico: `${BASE_SPACING / 4}rem`,
  micro: `${BASE_SPACING / 2}rem`,
  nano: `${BASE_SPACING * 0.75}rem`,
  xxs: `${BASE_SPACING}rem`,
  compact: `${BASE_SPACING * 1.5}rem`,
  xs: `${BASE_SPACING * 2}rem`,
  sm: `${BASE_SPACING * 3}rem`,
  md: `${BASE_SPACING * 4}rem`,
  lg: `${BASE_SPACING * 5}rem`,
  xl: `${BASE_SPACING * 6}rem`,
  xxl: `${BASE_SPACING * 8}rem`,
  xxxl: `${BASE_SPACING * 9}rem`,
} as const

/**
 * Semantic spacing tokens — named by purpose rather than size.
 * Use these in preference to raw spacing values wherever the intent is clear.
 */
export const semanticSpacing = {
  /** Gap between a section heading and its content items */
  sectionLabelGap: spacing.xs,
  /** Gap between consecutive sections */
  sectionGap: spacing.sm,
} as const

export type Spacing = typeof spacing
export type SemanticSpacing = typeof semanticSpacing
